import TableAHSF from "../../../../Components/TableAHSF";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { decryptToken } from "../../../../Services/Encryption/EncryptionParams";
import ObjectivesAactivitiesAdd from "./ObjectivesAactivitiesAdd";
import { DeleteObjectivesAndActivities } from "../../../../Redux/Reducers/Submitter/ObjectivesAndActivities";
import { useEffect, useState } from "react";
import PopupAHSF from "../../../../Components/PopupAHSF";
import { setRefreshTable } from "../../../../Redux/Reducers/Shared/VariousVariables";

const ObjectivesAactivities = (props) => {
  const lodingAdd = useSelector(
    (state) => state.ObjectivesAndActivitiesReducers.AddObjectivesAndActivities
  );
  const lodingEdit = useSelector(
    (state) => state.ObjectivesAndActivitiesReducers.EditObjectivesAndActivities
  );
  const lodingDelete = useSelector(
    (state) =>
      state.ObjectivesAndActivitiesReducers.DeleteObjectivesAndActivities
  );

  const AppGuid = useParams();
  const [PopupComponentEditStatus, setPopupComponentEditStatus] =
    useState(false);
  const [objectivesAndActivitiesId, setObjectivesAndActivitiesId] =
    useState(null);
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      jsonData: state.FetchDataJson.JsonData,
      // ActiveRound: state.ApplicationInformation.ActiveRound,
      ApplicationInformation:
        state.ApplicationInformationReducer.ApplicationInformation,
    };
  });
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const PopupOPjectData = {
    isPopupOpenStatus: true,
    isPopupOpenFunction: () => {},

    componentBody: (
      <ObjectivesAactivitiesAdd
        shouldDisableFields={props.shouldDisableFields}
      />
    ),
    maxWidth: "500px",

    maxHeight: "900px",
    title: "الأهداف",
  };
  const RequestsColumns = [];
  const RequestAccessor = [
    {
      KeyName: "objectivesName",
      ShowStatus: true,
      NmaeColumn: "الهدف",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "activities",
      ShowStatus: true,
      NmaeColumn: "النشاط",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "implementationList",
      ShowStatus: true,
      NmaeColumn: "مراحل التنفيذ",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "schumannsContribution",
      ShowStatus: true,
      NmaeColumn: "مجموع مساهمة شومان",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      comma:true

    },
  ];
  const OtherMainBtns = [
    {
      Click: async (e) => {
        Swal.fire({
          title: state.jsonData.deleteTitlePopUp?.nameAR,
          icon: "error",
          // iconHtml: "؟",
          confirmButtonText: "تأكيد",
          cancelButtonText: "الغاء",
          showCancelButton: true,
          showCloseButton: true,
        }).then((res) => {
          if (res.isConfirmed == true) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "تم الحذف بنجاح",
              showConfirmButton: false,
              timer: 1500,
              // width: "500px",
            });
            //delete ow from table by id after confirmed

            dispatch(
              DeleteObjectivesAndActivities({
                objectivesAndActivitiesId: e.target.value,
              })
            );
          }
        });
      },
      content: "",
      className: "bi bi-trash",
      id: "deleteBtn",
      title: "حذف",
      ShowStatus: !props.shouldDisableFields,
    },
    {
      Click: async (e) => {
        setObjectivesAndActivitiesId(e.target.value);
        closePopupEditComponent();
      },
      content: "",
      className: !props.shouldDisableFields
        ? "bi bi-pencil-square"
        : "bi bi-view-list",
      id: "editBtn",
      title: "عرض",
      ShowStatus: true,
    },
  ];
  const closePopupEditComponent = () => {
    if (PopupComponentEditStatus) {
      setPopupComponentEditStatus(false);
    } else {
      setPopupComponentEditStatus(true);
    }
  };
  useEffect(() => {
    dispatch(setRefreshTable());
  }, [lodingDelete, lodingEdit, lodingAdd]);
  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"objectivesAndActivitiesId"}
        valueButtonAction={"objectivesAndActivitiesId"}
        URL={`api/SU_NT_WPB_ObjectivesAndActivities/GetAllObjectivesAndActivitiesByAppGuid`}
        UrlBody={{
          applicationInformationId:
            localStorage.getItem("ApplicationInformationId") ||
            props.applicationGuid,
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={""}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={!props.shouldDisableFields}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={false}
        arrayButton={OtherMainBtns}
        arrayButtonLastIndex={false}
        ArrayNameDataColum={RequestsColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
      />

      <PopupAHSF
        title={"انشطة الاهداف"}
        componentBody={
          <ObjectivesAactivitiesAdd
            ViewData={true}
            disabledData={false}
            Action={"edit"}
            objectivesAndActivitiesId={objectivesAndActivitiesId}
            shouldDisableFields={props.shouldDisableFields}
          />
        }
        maxWidth="500px"
        maxHeight="800px"
        isPopupOpenStatus={PopupComponentEditStatus}
        isPopupOpenFunction={closePopupEditComponent}
      />
    </>
  );
};

export default ObjectivesAactivities;
